import * as React from "react";
import TruncatedText from "shiitake";
import { LocalizedText } from "@shared-ui/localization-context";

import { UitkCardAlohaContentSection } from "uitk-react-cards";
import { UitkSpacing, UitkSpacingProps } from "uitk-react-spacing";

import { ReviewCountAndRating } from "components/flexComponents/Hotels/components/ReviewCountAndRating";

import { DescriptionAndGuestReviewSectionProps } from "components/flexComponents/Packages/typings";
import { Package } from "typings/microserviceModels/packaging-flex-module";

export const DescriptionAndGuestReviewSection: React.FC<DescriptionAndGuestReviewSectionProps> = ({
  packageItem,
  language,
  renderReviewRating,
  marginOnTop,
}) => {
  if (!packageItem.hotelDescription && !packageItem.showHotelGuestRating && !showFeaturedGuestReview(packageItem)) {
    return null;
  }
  const reviewRatingborder: UitkSpacingProps["border"] =
    packageItem.hotelDescription && showFeaturedGuestReview(packageItem) ? ["blockstart"] : [];

  const hotelDescription = (
    <UitkSpacing padding={{ inline: "three" }}>
      <TruncatedText
        lines={linesForTruncation(packageItem.descriptionLength)}
        renderFullOnServer={true}
        className="truncatedDescription uitk-type-paragraph-300 all-b-padding-three"
        tagName="p"
      >
        {packageItem.hotelDescription}
      </TruncatedText>
    </UitkSpacing>
  );

  const hotelDescriptionProvided = packageItem.hotelDescription?.length > 0;
  const reviewRatingPadding: UitkSpacingProps["padding"] = {
    inline: "three",
    block: hotelDescriptionProvided ? "three" : undefined,
    blockend: !hotelDescriptionProvided ? "three" : undefined,
  };

  const hotelGuestRating = (
    <UitkSpacing padding={reviewRatingPadding} border={reviewRatingborder}>
      <UitkCardAlohaContentSection padded={false}>
        <ReviewCountAndRating
          hotelOverallReviewRating={Number(packageItem.hotelReviewScore)}
          reviewCount={Number(packageItem.hotelReviewTotal)}
          language={language}
          marginOnTop={marginOnTop}
        />
      </UitkCardAlohaContentSection>
    </UitkSpacing>
  );

  const guestReviewBorder = hotelDescriptionProvided && !renderReviewRating ? "top" : undefined;
  const guestReviewPadding: UitkSpacingProps["padding"] = {
    inline: renderReviewRating ? "three" : undefined,
    blockend: renderReviewRating ? "three" : undefined,
    blockstart: !renderReviewRating && hotelDescriptionProvided ? "three" : undefined,
  };

  const guestReview = (
    <UitkSpacing padding={guestReviewPadding}>
      <UitkCardAlohaContentSection border={guestReviewBorder} padded={false}>
        <TruncatedText
          lines={linesForTruncation(packageItem.hotelReviewLength)}
          renderFullOnServer={true}
          className="truncatedReview uitk-type-paragraph-300"
          tagName="p"
          overflowNode={"\u2026\u0022"}
        >
          {`\u0022${packageItem.hotelReviewSample}`}
        </TruncatedText>
        <p className="reviewedOn uitk-type-paragraph-200" data-testid="hotel-reviewed-on">
          <LocalizedText message="hotels.review.reviewedOn" data={[packageItem.hotelReviewDate]} />
        </p>
      </UitkCardAlohaContentSection>
    </UitkSpacing>
  );

  return (
    <>
      {hotelDescriptionProvided && hotelDescription}
      {renderReviewRating && packageItem.showHotelGuestRating && hotelGuestRating}
      {showFeaturedGuestReview(packageItem) && guestReview}
    </>
  );
};

const showFeaturedGuestReview = (packageItem: Package) => {
  return packageItem.showHotelReview && packageItem.hotelReviewSample !== null && packageItem.hotelReviewSample !== "";
};

export function linesForTruncation(lines: string) {
  return lines === "four-lines" ? 4 : 2;
}

export default DescriptionAndGuestReviewSection;
